import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import { Provider } from 'react-redux';
import { store, persistor } from 'shared/redux/Store';
import { PersistGate } from 'redux-persist/integration/react';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { QueryClientProvider } from 'react-query';
import { queryClient } from 'shared/utils/QueryClient';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <QueryClientProvider client={queryClient} contextSharing>
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            {/* <React.StrictMode> */}
            <App />
            {/* </React.StrictMode> */}
        </PersistGate>
    </Provider>
    </QueryClientProvider>
);
